module.exports = __webpack_public_path__ + "img/icon-team-white.097c221d.svg";